var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.side_menu_bar}},[_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _vm.childFunction(item)}}},[_vm._v(_vm._s(item))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }